import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ThemesService from "../api/themes";
import TemplateTable from "../common/Layout/templatePages/templateTable";
import handleNavigate from "../common/customFunctions/handleNavigate";
import { useNavigate } from "react-router-dom";
import { setThemeLinking } from "../store/themeLinkingSlice";

function ThemesApiLinkingTab() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const organziation = useSelector(({ organziation }) => organziation);
  const [loadingValue, setLoadingValue] = useState(true);
  const [thmesLinking, setThemesLinking] = useState([]);

  useEffect(() => {
    getThemes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getThemes() {
    console.log("getTags");
    setLoadingValue(true);
    const orgObj = JSON.parse(localStorage.getItem("defaultOrganization"));
    const apiKey =
      organziation?.api_key_list?.[0]?.key ?? orgObj?.api_key_list?.[0]?.key;

    ThemesService.getThemeProfileLink({
      operation_profile_id: "",
      apiKey,
    })
      .then((jsonCurrent) => {
        if (jsonCurrent?.theme_profile_link?.length) {
          setThemesLinking(jsonCurrent?.theme_profile_link);
        }
        setLoadingValue(false);
      })
      .catch((errorr) => {
        if (process.env.NODE_ENV === "development")
          console.log("getUserTypePermissionserrorr", errorr);
      });
  }
  const handleButton = (event, buttonType, row) => {
    if (buttonType === "edit") {
      handleEditThemeLinkingProfile(event, row);
    }
  };
  const handleEditThemeLinkingProfile = (event, row) => {
    dispatch(
      setThemeLinking({
        operation_profile_id: row.operation_profile_id,
        theme_profile_id: row.theme_profile_id,
        theme_profile_link_id: row.theme_profile_link_id,
        status: row.status,
      })
    );
    event.stopPropagation();
    handleNavigate(
      event,
      navigate,
      `/addEditThemeLinking?id=${row.theme_profile_link_id}`
    );
  };
  return (
    <>
      <TemplateTable
        headCells={[
          { id: "operation_profile_id", label: "OrganizationId" },
          { id: "theme_profile_id", label: "ThemeId" },
          { id: "status", label: "Status" },
          {
            id: "action",
            buttons: ["edit"],
          },
        ]}
        handleButton={handleButton}
        itemsList={thmesLinking}
        itemId="operation_profile_id"
        loading={loadingValue}
        searchAttributes={["operation_profile_id", "theme_profile_id"]}
        allowExport
        exportTitle={t("Linking")}
      />
    </>
  );
}

export default ThemesApiLinkingTab;
